/**
 * Realizacje Odmiana - Portfolio Gallery with Lightbox
 */

(function() {
  'use strict';

  // ===============================================
  // LIGHTBOX
  // ===============================================

  const lightbox = {
    modal: null,
    image: null,
    counter: null,
    prevBtn: null,
    nextBtn: null,
    closeBtn: null,
    currentImages: [],
    currentIndex: 0,

    init() {
      this.modal = document.getElementById('lightboxModal');
      this.image = document.getElementById('lightboxImage');
      this.counter = document.getElementById('lightboxCounter');
      this.prevBtn = document.getElementById('lightboxPrev');
      this.nextBtn = document.getElementById('lightboxNext');
      this.closeBtn = document.getElementById('lightboxClose');

      if (!this.modal) return;

      this.bindEvents();
    },

    bindEvents() {
      // Portfolio cards click
      document.querySelectorAll('.portfolio-card-realizacje').forEach(card => {
        card.addEventListener('click', (e) => {
          e.preventDefault();
          this.openFromCard(card);
        });
      });

      // Close button
      this.closeBtn.addEventListener('click', () => this.close());

      // Navigation
      this.prevBtn.addEventListener('click', () => this.prev());
      this.nextBtn.addEventListener('click', () => this.next());

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (!this.modal.classList.contains('active')) return;

        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.prev();
        if (e.key === 'ArrowRight') this.next();
      });

      // Click outside to close
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.close();
      });
    },

    openFromCard(card) {
      // Get all images from this card's hidden data
      const dataContainer = card.querySelector('.portfolio-data-realizacje');
      if (!dataContainer) return;

      const images = dataContainer.querySelectorAll('[data-lightbox-image]');
      if (images.length === 0) return;

      // Store images
      this.currentImages = Array.from(images).map(img => ({
        src: img.src,
        alt: img.alt
      }));

      this.currentIndex = 0;
      this.open();
    },

    open() {
      if (this.currentImages.length === 0) return;

      this.showImage(0);
      this.modal.classList.add('active');
      this.modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.modal.classList.remove('active');
      setTimeout(() => {
        this.modal.style.display = 'none';
      }, 300);
      document.body.style.overflow = '';
    },

    showImage(index) {
      if (index < 0 || index >= this.currentImages.length) return;

      this.currentIndex = index;
      const imageData = this.currentImages[index];

      // Update image
      this.image.src = imageData.src;
      this.image.alt = imageData.alt;

      // Update counter
      this.counter.textContent = `${index + 1} / ${this.currentImages.length}`;

      // Update buttons
      this.prevBtn.disabled = index === 0;
      this.nextBtn.disabled = index === this.currentImages.length - 1;
    },

    prev() {
      if (this.currentIndex > 0) {
        this.showImage(this.currentIndex - 1);
      }
    },

    next() {
      if (this.currentIndex < this.currentImages.length - 1) {
        this.showImage(this.currentIndex + 1);
      }
    }
  };

  // ===============================================
  // FILTERS
  // ===============================================

  const filters = {
    init() {
      const filterBtns = document.querySelectorAll('.filter-btn-realizacje');
      if (filterBtns.length === 0) return;

      filterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const filter = btn.getAttribute('data-filter');
          this.applyFilter(filter);

          // Update active state
          filterBtns.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
        });
      });
    },

    applyFilter(filter) {
      const cards = document.querySelectorAll('.portfolio-card-realizacje');

      cards.forEach(card => {
        if (filter === 'all') {
          card.classList.remove('hidden');
          return;
        }

        const room = card.getAttribute('data-room');
        const pkg = card.getAttribute('data-package');

        // Check if filter matches room or package
        const matches = (
          room === filter ||
          pkg === filter
        );

        if (matches) {
          card.classList.remove('hidden');
        } else {
          card.classList.add('hidden');
        }
      });
    }
  };

  // ===============================================
  // INIT
  // ===============================================

  function init() {
    lightbox.init();
    filters.init();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
